"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PeoplesCostomize = _interopRequireDefault(require("@rsuite/icon-font/lib/people/PeoplesCostomize"));

// Generated by script, don't edit it please.
var PeoplesCostomize = (0, _createSvgIcon["default"])({
  as: _PeoplesCostomize["default"],
  ariaLabel: 'peoples costomize',
  category: 'people',
  displayName: 'PeoplesCostomize'
});
var _default = PeoplesCostomize;
exports["default"] = _default;
module.exports = exports.default;